import { i18n } from "../i18n";
import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, Menu } from "./types";

const { t } = i18n.global;

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "preset" } },
  { component: "ConfSection", props: { name: "saveSettings" } },
  { component: "TerraTechWorldsCustomSettings", props: { name: "custom" } },
  { component: "TerraTechWorldsCreativeSettings", props: { name: "creativeOnlyOptions" } },
];

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const join = () => {
  window.open(t("ngp/settings/section/terratech_worlds_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  join: {
    buttonTextKey: "ngp/settings/section/terratech_worlds_wiki",
    joinFn: join,
  },
});
